import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  classificationContainer: {
    marginTop: 16,

    '& h2': {
      fontSize: 18,
      fontWeight: 600,
      color: theme.palette.primary.main,
      marginBottom: 16
    }
  },

  classificationContent: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    borderRadius: 8
  },

  classificationItem: {
    display: 'flex',
    gap: 8,
    '& span:first-child': {
      display: 'block',
      fontSize: 18,
      fontWeight: 400,
      color: theme.palette.primary.dark
    },

    '& span:last-child': {
      display: 'block',
      fontSize: 18,
      fontWeight: 500,
      color: theme.palette.primary.main
    }
  },

  classificationFooter: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  classificationFooterContent: {
    display: 'flex',
    gap: 8,

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      width: '100%',

      '& button': {
        width: '100%'
      }
    }
  }
}))
